import { render, staticRenderFns } from "./ApprovalListTable.vue?vue&type=template&id=2bc867d3&scoped=true"
import script from "./ApprovalListTable.vue?vue&type=script&lang=js"
export * from "./ApprovalListTable.vue?vue&type=script&lang=js"
import style0 from "./ApprovalListTable.vue?vue&type=style&index=0&id=2bc867d3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc867d3",
  null
  
)

export default component.exports